import { CheckCircleTwoTone, PhoneOutlined } from "@ant-design/icons";
import { Col, Row, Space, Typography } from "antd";

import { ModalSimilars } from "../ModalSimilars/web";
import { useIsAuthModalShowing } from "../../../GlobalHooks/useIsAuthModalShowing";
import { useTheme } from "../../../Styles/ThemeHook";

type Props = {
	visible:boolean,
	onCancel:()=>void,
	loading:boolean,
	owner_name:string,
	phone:string,
	property_id: string | number,
	mode?:any,
	onClick?: () => void,
}

export const ModalPhone = (props:Props) => {
	const { theme } = useTheme();
	const { isAuthModalShowing } = useIsAuthModalShowing();

	let phones = [];
	if (typeof props.phone != "undefined" && props.phone) phones = props.phone.split(";");

	return (
		<ModalSimilars
			mode={props.mode}
			visible={props.visible && !isAuthModalShowing}
			onCancel={props.onCancel}
			property_id={props.property_id}>
			<Row
				className={"modal-phone-content"}
				justify={"center"}
				style={{ textAlign: "center" }}
				gutter={[0, theme.spacing.xsSpacing]}>
				<Col span={24}>
					<CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "25px" }} />
				</Col>
				<Col span={24}>
					<Typography.Text strong>
						{"¡No pierdas tiempo y llamá ahora!"}
					</Typography.Text>
				</Col>
				<Col span={24}>
					<Typography.Text strong>{props.loading ? "loading" : props.owner_name}</Typography.Text>
				</Col>
				<Col span={24}>
					<Row gutter={theme.spacing.lgSpacing} justify={"center"}>
						{phones.map((p, i) => (
							<Col key={"phone_" + i}>
								<a href={"tel:" + p} onClick={props.onClick}>
									<Space size={theme.spacing.xsSpacing}>
										<PhoneOutlined style={{ color: theme.colors.linkColor }} />
										<Typography.Text style={{ color: theme.colors.linkColor }}>
											{props.loading ? "loading" : p}
										</Typography.Text>
									</Space>
								</a>
							</Col>
						))}
					</Row>
				</Col>
			</Row>
		</ModalSimilars>
	);
};


